import React from 'react';

// Extracted verbatim from Landing.jsx's main tabbed portal (previously the
// `userType === 'otp'` block). Behavior/markup unchanged. handleSendOTP and
// the countdown timer effect stay owned by Landing.jsx and are passed down
// as props — see authRegistry.js for how this is wired.
const OTPLoginFields = ({
    portalData,
    formData,
    handleInputChange,
    otpMethod,
    setOtpMethod,
    otpSent,
    otpTimer,
    handleSendOTP,
    loading,
    primaryColor,
    btnStyle,
    // The masked number a code already went to (the page opened again) — Landing.jsx pendingCode.
    pendingHint,
}) => {
    // Only the channel(s) the branch allows (portalData.otpChannels; absent = both).
    // With just one there is nothing to choose, so no toggle.
    const channels = Array.isArray(portalData?.otpChannels) && portalData.otpChannels.length
        ? portalData.otpChannels
        : ['whatsapp', 'sms'];
    return (
    <div className="animate-fade-in">
        {channels.length > 1 && (
        <div className="otp-method-toggle">
            {channels.includes('whatsapp') && (
            <button
                type="button"
                className={`otp-method-btn ${otpMethod === 'whatsapp' ? 'active' : ''}`}
                onClick={() => setOtpMethod('whatsapp')}
                style={otpMethod === 'whatsapp' ? { borderColor: primaryColor, color: primaryColor } : {}}
            >
                <i className="fab fa-whatsapp"></i> WhatsApp
            </button>
            )}
            {channels.includes('sms') && (
            <button
                type="button"
                className={`otp-method-btn ${otpMethod === 'sms' ? 'active' : ''}`}
                onClick={() => setOtpMethod('sms')}
                style={otpMethod === 'sms' ? { borderColor: primaryColor, color: primaryColor } : {}}
            >
                <i className="fas fa-sms"></i> SMS
            </button>
            )}
        </div>
        )}
        <div className="form-group">
            <label>Mobile Number</label>
            <div style={{ display: 'flex', gap: '10px' }}>
                <div className="input-with-icon" style={{ flexGrow: 1 }}>
                    <i className="fas fa-mobile-alt"></i>
                    <input
                        type="tel"
                        name="mobile"
                        className="input"
                        placeholder={pendingHint ? `Code sent to ${pendingHint}` : 'Enter mobile number'}
                        required={!pendingHint}
                        value={formData.mobile}
                        onChange={handleInputChange}
                    />
                </div>
                <button
                    type="button"
                    className="btn btn-secondary"
                    onClick={handleSendOTP}
                    disabled={loading || otpTimer > 0}
                    style={{ minWidth: '100px', ...btnStyle, opacity: (loading || otpTimer > 0) ? 0.7 : 1 }}
                >
                    {otpTimer > 0 ? `${otpTimer}s` : 'Send OTP'}
                </button>
            </div>
        </div>

        {otpSent && (
            <div className="form-group animate-fade-in">
                <label>Enter OTP</label>
                <div className="input-with-icon">
                    <i className="fas fa-lock"></i>
                    <input
                        type="text"
                        name="otp"
                        className="input"
                        inputMode="numeric"
                        autoComplete="one-time-code"
                        placeholder="6-digit Code"
                        required
                        value={formData.otp}
                        onChange={handleInputChange}
                        maxLength={6}
                    />
                </div>
            </div>
        )}
    </div>
    );
};

export default OTPLoginFields;
